import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

@Injectable({ providedIn: 'root' })
export class ActualitesService {
  constructor(private api: ApiService) {}

  /**
   * GET /api//api/communication/actualites?page=&search=
   * Fetch paginated list of actualités with optional search
   */
  getActualites(page: number, limit = 8, search = '', status = ''): Observable<any> {
    return this.api.post('/api/communication/actualites/list', {
      page,
      limit,
      search:  search  || null,
      status:  status  || null,
    });
  }

  /**
   * GET /api//api/communication/actualites/:id
   * Fetch a single actualité by ID
   */
  getActualiteById(id: number): Observable<any> {
    return this.api.get(`/api/communication/actualites/${id}`);
  }

  /**
   * POST /api//api/communication/actualites
   * Create a new actualité (multipart form with image)
   */
  createActualite(formData: FormData): Observable<any> {
    return this.api.post('/api/communication/actualites', formData);
  }

  /**
   * PUT /api//api/communication/actualites/:id
   * Update an actualité (multipart form with optional image)
   */
  updateActualite(id: number, formData: FormData): Observable<any> {
    return this.api.put(`/api/communication/actualites/${id}`, formData);
  }

  /**
   * PATCH /api//api/communication/actualites/:id/status
   * Toggle the status of an actualité (ACTI <-> INAC)
   */
  setStatus(id: number, status: 'ACTI' | 'INAC' | 'ARCH'): Observable<any> {
    return this.api.patch(`/api/communication/actualites/${id}/status`, { status });
  }

  /**
   * DELETE /api//api/communication/actualites/:id
   * Delete an actualité
   */
  deleteActualite(id: number): Observable<any> {
    return this.api.delete(`/api/communication/actualites/${id}`);
  }
}
